<template>
  <vs-row vs-justify="center" id="customers-box">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <vs-row class="w-25">
          <vs-col vs-w="9"></vs-col>

          <vs-col vs-w="3">
            <vs-button id="add-service-form" class="mr-2 w-100" icon="check" color="primary" @click="showPopup()"
            :disabled="parentRequest && parentRequest.delivered == 1 ? true : false" >{{ $t("RequestTT.MarkDelivered")
              }}</vs-button>
          </vs-col>
        </vs-row>
      </vs-card>
      <CustomizerSidebar ref="AddCustomer" @hide="hide" :reseller_new="true" :sideBarTitle="$t('Reseller.Add.Title')">
      </CustomizerSidebar>
      <vs-card>

        <div slot="header">

        </div>

        <vs-tabs>

          <!-- Detail request TAB -->

          <vs-tab :label="$t('RequestTT.Details')" icon="check_box" id="approved-tab">
            <vs-row>
              <vs-input v-model="deep" type="number" min="1" />
              <vs-checkbox v-model="showIcon">{{ $t('RequestTT.ChildDetails') }}</vs-checkbox>
              <vs-checkbox v-model="showLength">{{ $t('RequestTT.ShowLength') }}</vs-checkbox>
              <vs-checkbox v-model="showLine">{{ $t('RequestTT.ChildDetails') }}</vs-checkbox>
              <vs-checkbox v-model="showLineNumber">{{ $t('RequestTT.ShowLineNumber') }}</vs-checkbox>
            </vs-row>
            <vue-json-pretty :deep="+deep" :showIcon="showIcon" :showLength="showLength" :showLine="showLine"
              :showLineNumber="showLineNumber" :data="jsonData" />
          </vs-tab>

          <vs-tab :label="$t('Customer.Tabs.All')" icon="list_alt" id="all-tab">
            <vs-table :sst="true" v-model="selected" :total="totalItems" max-items="10" :data="childRequests">
              <template slot="thead">
                <vs-th sort-key="contactname">{{
                  $t("RequestTT.Table.CR")
                }}</vs-th>
                <vs-th sort-key="joindate">{{
                  $t("RequestTT.Table.CreatedAt")
                }}</vs-th>
                <vs-th sort-key="phone">{{ $t("RequestTT.Table.ExternalId") }}</vs-th>
                <vs-th sort-key="book_id">{{
                  $t("RequestTT.Table.Status")
                }}</vs-th>
                <vs-th>{{ $t("Customer.Table.Options") }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].contract_resource">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <h5 class="mb-0 font-16">
                          {{ data[indextr].contract_resource }}
                        </h5>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    <div class="d-flex align-items-center">
                      {{ $moment(data[indextr].created_at).format('llll') }}
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].external_id">
                    <div class="d-flex align-items-center">
                      {{ data[indextr].external_id }}
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].delivered">
                    <div class="d-flex align-items-center">
                      <div v-if="data[indextr].delivered == 0" style="display: flex;">
                        <div :class="dotStyle ? 'pending-dot-red' : 'pending-dot-red pending-dot-white'"></div>
                        <span class="text-muted">{{ $t("RequestTT.Pending") }}</span>
                      </div>
                      <div style="display: flex;" v-else>
                        <i class="mdi mdi-checkbox-marked-circle mr-2 display-8"></i>
                        <span class="text-muted m-auto">{{ $t("RequestTT.Delivered") }}</span>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td>
                    <div class="btn-alignment">
                      <vs-button radius color="primary" type="border" icon="check"
                        :disabled="data[indextr] && data[indextr].delivered == 1 ? true : false"
                        @click="showPopup(data[indextr].id)"></vs-button>

                      <vs-button radius color="warning" type="border" icon="visibility"
                        @click="showPopupDetail(data[indextr].request)"></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination @change="handleChangePage" :total="totalPages" v-model="currentPage"></vs-pagination>
          </vs-tab>


        </vs-tabs>
      </vs-card>
      <v-tour name="CustomersA" :steps="steps">
        <template slot-scope="tour">
          <transition name="fade">
            <v-step v-for="(step, index) of tour.steps" v-if="tour.currentStep === index" :key="index" :step="step"
              :previous-step="tour.previousStep" :next-step="tour.nextStep" :stop="tour.stop" :is-first="tour.isFirst"
              :is-last="tour.isLast" :labels="tour.labels">
              <template v-if="tour.currentStep === 0">
                <div slot="actions" class="v-step__buttons">
                  <button @click="promptShow" class="v-step__button">
                    Next
                  </button>
                </div>
              </template>
              <template v-if="tour.currentStep === 1">
                <div slot="actions" class="v-step__buttons">
                  <button @click="tour.previousStep" class="v-step__button">
                    Previous
                  </button>
                  <button @click="goToNextPage" class="v-step__button">
                    Next
                  </button>
                </div>
              </template>
            </v-step>
          </transition>
        </template>
      </v-tour>
    </vs-col>
    <vs-prompt @accept="markAsDelivered(parentRequest.id)" color="primary" @cancel="close" @close="close"
      :active.sync="showMarkPopup">
      <div class="con-exemple-prompt">
        {{ $t('RequestTT.MarkParent') }} {{ parentRequest && parentRequest.contract_resource ? parentRequest.contract_resource : "" }} {{ $t('RequestTT.MarkParentEnd') }}
      </div>
    </vs-prompt>
    <vs-popup color="primary" :title="$t('RequestTT.ChildDetails')" @cancel="closeDetail" @close="closeDetail"
      :active.sync="showDetailChild">
      <div style="width: 2200px;">
        <vs-row style="margin-top: 10px; margin-bottom: 30px; padding: 0 10px;">
              <vs-input v-model="deep" type="number" min="1" />
              <vs-checkbox v-model="showIcon">{{ $t('RequestTT.ChildDetails') }}</vs-checkbox>
              <vs-checkbox v-model="showLength">{{ $t('RequestTT.ShowLength') }}</vs-checkbox>
              <vs-checkbox v-model="showLine">{{ $t('RequestTT.ChildDetails') }}</vs-checkbox>
              <vs-checkbox v-model="showLineNumber">{{ $t('RequestTT.ShowLineNumber') }}</vs-checkbox>
            </vs-row>
            <vue-json-pretty :deep="+deep" :showIcon="showIcon" :showLength="showLength" :showLine="showLine"
              :showLineNumber="showLineNumber" :data="selectedChildDetailJson" />
      </div>
    </vs-popup>
  </vs-row>
</template>
  
<script>
import { requestTTService, resellerService } from "../../_services";
import CustomizerSidebar from "../../layout/full/customizer/CustomizerSidebar.vue";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
// moment

export default {
  name: "Customers",
  data: () => ({
    showMarkPopup: false,
    showDetailChild: false,
    childRequests: [],
    parentRequest: null,
    disapprovedBusinesses: [],
    selected: {},
    totalItems: 1,
    totalPages: 1,
    currentPage: 1,
    perPage: 10,
    steps: [
      {
        target: "#add-customer-form", // We're using document.querySelector() under the hood
        header: {
          title: "Get Started",
        },
        params: {
          placement: "right-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#edit-customer-button",
        params: {
          placement: "auto", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
    ],
    current_page: 1,
    per_page: 10,
    jsonData: {},
    selectedChildDetailJson: {},
    deep: 3,
    showLength: true,
    showIcon: true,
    showLine: true,
    showLineNumber: false,
    selectedChildRequestId: null,
    _interval: null,
    dotStyle: true
  }),
  methods: {
    toggleDot() {
      if (this.dotStyle) {
        this.dotStyle = false;
      } else {
        this.dotStyle = true;
      }
    },
    hide() {
      this.$emit("hide", "hide");
    },
    openAddCustomer() {
      this.$refs.AddCustomer.show();
    },
    Closed() {
      this.$vs.notify({
        color: "danger",
        title: "Delete Cancel",
        text: "Cancelling!",
      });
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#customers-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#customers-box > .con-vs-loading");
    },
    handleChangePage() {
      let query = `?current_page=${this.currentPage}&per_page=${this.perPage}`
      this.showLoading();
      requestTTService
        .getByParentId(this.$route.params.id, query).then(
          function (res) {
            this.jsonData = res.parent.request;
            this.childRequests = res.data.data;
            this.parentRequest = res.parent;
            this.totalItems = res.data.total;
            this.currentPage = res.data.current_page;
            this.totalPages = res.data.last_page;
          }.bind(this)
        )
        .finally(
          function () {
            this.hideLoading();
          }.bind(this)
        );
    },
    close() {
      this.showMarkPopup = false;
    },
    closeDetail() {
      this.showDetailChild = false;
      this.disapprovedBusinesses = {};
    },

    showPopup(id = null) {
      this.showMarkPopup = true;
      this.selectedChildRequestId = id;
    },
    showPopupDetail(json) {
      this.showDetailChild = true;
      this.selectedChildDetailJson = json;
    },

    showRequest(request_id) {
      this.$router.push('/request-tt/show/' + request_id);
    },

    markAsDelivered(id) {
      if (this.selectedChildRequestId != null) {
        id = this.selectedChildRequestId
      }
      this.showLoading();
      requestTTService
        .markDelivered(id)
        .then(
          function (res) {
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("RequestTT.ToastSuccessMarked"),
              "success"
            );
          }.bind(this)
        )
        .catch(
          function () {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Request.ToastFailMessage"),
              "danger"
            );
          }.bind(this)
        )
        .finally(() => {
          this.hideLoading();
        });
    }
  },
  computed: {
    events() {
      return this.$store.state.contactEvents;
    },
    validateAddCustomerForm() {
      // return this.fname.length > 0;
      // return true
    },
  },

  components: {
    CustomizerSidebar,
    VueJsonPretty,
  },

  mounted() {
    this._interval = setInterval(this.toggleDot, 2000);

    this.handleChangePage();
  },
  beforeDestroy() {
    clearInterval(this._interval);
  },
};
</script>
<style lang="scss">
.con-vs-popup {

  .vs-popup {
    width: 70vw !important; //You can change the width according to your content
    height: auto;
  }

}
</style>
<style scoped>
.verified-icon {
  display: inline-block;
  font-size: 20px;
}

.mdi-check-circle {
  color: green;
}

.mdi-close-circle {
  color: red;
}

.pending-dot-red {
  width: 9px;
  height: 9px;
  border-radius: 100%;
  background-color: red;
  margin: auto;
  margin-right: 7px;
  -webkit-transition: background-color 2s ease-out;
  -moz-transition: background-color 2s ease-out;
  -o-transition: background-color 2s ease-out;
  transition: background-color 2s ease-out;
}

.pending-dot-white {
  background-color: white;
}
</style>
  